import { CustomTableColumn } from "./custom-table-column";

export class TimerTableColumn extends CustomTableColumn {
    endTimestampPath: string;
    constructor(name: string, label: string, startTimestampPath: string, endTimestampPath: string) {
        super(name, label, startTimestampPath);
        this.endTimestampPath = endTimestampPath;
    }
}
